import React from "react";
import "./ContactSection.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const ContactSection = () => {
  return (
    <div className="contact-wrapper">

      {/* TOP HEADER */}
      <div className="contact-header">

        <button className="contact-pill">Get In Touch</button>

        <h1>Contact Us</h1>

        <p>
          Schedule a consultation today and take the first step towards
          resolving your legal matters
        </p>

      </div>

      <div className="contact-container">

        {/* LEFT CONTACT INFO */}

        <div className="contact-info">

          <h2>Contact Information</h2>

          <p>Say something to start a live chat!</p>

          <div className="info-item">
            <FaPhoneAlt />
            <span>+1012 3456 789</span>
          </div>

          <div className="info-item">
            <FaEnvelope />
            <span>demo@gmail.com</span>
          </div>

          <div className="info-item">
            <FaMapMarkerAlt />
            <span>
              132 Dartmouth Street Boston, <br />
              Massachusetts 02156 United States
            </span>
          </div>

        </div>

        {/* RIGHT FORM */}

        <div className="contact-form">

          <div className="form-row">

            <div className="input-group">
              <label>First Name</label>
              <input type="text" />
            </div>

            <div className="input-group">
              <label>Last Name</label>
              <input type="text" placeholder="Doe"/>
            </div>

          </div>

          <div className="form-row">

            <div className="input-group">
              <label>Email</label>
              <input type="email" />
            </div>

            <div className="input-group">
              <label>Phone Number</label>
              <input type="text" placeholder="+1 012 3456 789"/>
            </div>

          </div>

          <div className="subject-section">

            <p>Select Subject?</p>

            <div className="radio-group">

              <label>
                <input type="radio" name="subject"/>
                General Inquiry
              </label>

              <label>
                <input type="radio" name="subject"/>
                General Inquiry
              </label>

              <label>
                <input type="radio" name="subject"/>
                General Inquiry
              </label>

              <label>
                <input type="radio" name="subject"/>
                General Inquiry
              </label>

            </div>

          </div>

          <div className="input-group message-box">
            <label>Message</label>
            <textarea placeholder="Write your message.."></textarea>
          </div>

          <button className="send-btn">Send Message</button>

        </div>

      </div>

      <div className="circle-bg"></div>

    </div>
  );
};

export default ContactSection;